// extracted by mini-css-extract-plugin
module.exports = {"commentsContainer":"FeatureComments_commentsContainer__Opl7A"};